<template>
	<div>
		<buttonlist
				@help="help"
			@search="search"
			@reflash="reflash"
			@exps="exps"
			ref="SetBtn"
		></buttonlist>
		<el-table
			:data="dataSet"
			v-loading="loading"
			:highlight-current-row="true"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			:height="tableHeight"
			header-row-class-name="headerclass"
			style="width: 100%; margin-top:0px"
			ref="singleTable"
		>
			<el-table-column type="selection" v-if="false"></el-table-column>
			<el-table-column show-overflow-tooltip prop="vender_code" :label="$t('getapi[1287]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="vender_name" :label="$t('getapi[1197]')"></el-table-column>
			<el-table-column prop="batchpriceflag" :label="$t('getapi[1424]')">
				<template slot-scope="scope">
					{{scope.row.batchpriceflag | thousandth}}
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip prop="relation_order_no" :label="$t('getapi[3102]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
			<el-table-column prop="batch_floor_limit" :label="$t('getapi[1289]')" align="right">
				<template slot-scope="scope">
					{{scope.row.batch_floor_limit | thousandth}}
				</template>
			</el-table-column>
			<el-table-column prop="net_unit_price" :label="$t('getapi[3711]')" align="right">
				<template slot-scope="scope">
					{{scope.row.net_unit_price | thousandthpurprice}}
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip prop="unit_price" :label="$t('getapi[3958]')" align="right">
				<template slot-scope="scope">
					{{scope.row.unit_price | thousandthpurprice}}
				</template>
			</el-table-column>
			<el-table-column prop="net_unit_priceold" :label="$t('getapi[1426]')" align="right">
				<template slot-scope="scope">
					{{scope.row.net_unit_priceold | thousandthpurprice}}
				</template>
			</el-table-column>
			<el-table-column prop="unit_priceold" :label="$t('getapi[1427]')" align="right">
				<template slot-scope="scope">
					{{scope.row.unit_priceold | thousandthpurprice}}
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip prop="change_type_flag" :label="$t('getapi[1428]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="change_reason" :label="$t('getapi[1429]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="pur_measure" :label="$t('getapi[1166]')"></el-table-column>
		</el-table>
		<el-row class="page">
			<el-col :span="18">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[100, 200, 300, 400]"
					:page-size="pageSize"
					:pager-count="5"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="6">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<serce :isVisible="isVisible" queryData="SchQtChangeLinesViewInfo" ref="ser" @getser="serclick"></serce>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'schqtchangelinedetail',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('schqtchangelinedetail'), // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
            scrollTop:0,
		};
	},
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })

    },
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[93]"),this.$t("getapi[17]"));
        },
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            if (that.total > 0) {
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
            } else {
                that.$refs.SetBtn.SetButtonEnable('search,refresh');
            }
		},
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('schqtchangelinedetail',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.$refs.ser.clearInput(that.isVisible, 'SchQtChangeLinesViewInfo');
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				SelectIndex: that.SelectIndexs,
				Param: datac
			};
			that.$http.urlpost('/Sch/Quotation/GetSchQtChangeLineView', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
					that.authority();
				}
			});
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		// 导出
		exps() {
			let that = this;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Ids: '',
				Param: datac,
                LangType: that.$processdata.getLang(),
                fromname: that.$t('getapi[1423]')
			};
            that.$refs.SetBtn.SetOneBtnEnable('exps',false);
			that.$http.urlpost('/Sch/Quotation/GetSchQtChangeLineViewToExecl', parm, function(res) {
                that.$refs.SetBtn.SetOneBtnEnable('exps',true);
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
			});
		},
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
